/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Dolma = ({ color = 'primary', aspectRatio = '704/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Dolma" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Dolma, Dolma as default };
